import MediaQueryConstants from './MediaQueryConstants'
export const MediaQueryState = (state) => state[MediaQueryConstants.reducerName]

export const isMobileSelector = (state) => MediaQueryState(state).screenSize.isMobile
export const hasMobileMenuSelector = (state) => MediaQueryState(state).screenSize.hasMobileMenu

export const isExtraLargeSelector = (state) => MediaQueryState(state).screenSize.extraLarge

export const breakpointSelector = (state) => MediaQueryState(state).screenSize.breakpoint

export default {
  isMobileSelector,
  hasMobileMenuSelector,
  isExtraLargeSelector,
  breakpointSelector
}



// WEBPACK FOOTER //
// ./src/redux-modules/media-query/MediaQuerySelectors.js